export const locale = {
  lang: 'de',
  data: {
    'LANDINFOCUS': {
      'ENCUESTAS':{
        'TITULO':'Dies ist ein Fokusbereichsprozess',
        'NO-ENCU':'Sie haben derzeit keinen zugewiesenen Umfrageprozess',
        'ENC-AUTO':'Autorisierte Umfrage',
        'ENC-CORRECI':'Die Umfrage wurde zur Korrektur gesendet',
        'MODAL_NO_COLAB_EMPRE':'Sie haben Ihre Contributor Base noch nicht hochgeladen, sind Sie sicher, dass Sie fortfahren möchten?',
      },
      'STATUS-ENCUESTA':{
        '1':'In Bearbeitung',
        '2':'Auswerten',
        '3':'Autorisiert',
        '5': 'Korrigiert',

      },
      'LISTA': {
        'TAB': 'Liste der Teilnehmer',
        'BUSCAR': {
          'INFO': 'Sie können nach einem oder mehreren Teilnehmern aus der Liste suchen, indem Sie den folgenden Namen eingeben',
          'PLACEHOLDER': 'Finde einen Teilnehmer'
        },
        'AGREGAR': {
          'BOTON': 'Fügen Sie einen Teilnehmer hinzu'
        },
        'TABLA': {
          'COLUMNAS': {
            'NOMBRE': 'Vollständiger Name',
            'EMAIL': 'Email',
            'ACCIONES': 'Mögliche Aktionen'
          }
        },
        'TOOLTIPS': {
          'AGREGAR': 'Fügen Sie der Liste einen Teilnehmer hinzu',
          'EDITAR': 'Bearbeiten Sie diese Teilnehmerdaten'
        }
      },
      'MODALES':{
        'CREARENC': 'Geben Sie den Namen der Umfrage ein',
        'CORRECTO': 'Es wurde korrekt hinzugefügt',
        'DELETE': 'Sie wurde korrekt entfernt',
        'COMDELETE': 'Korrekt entfernt',
        'RSPSI': 'JA',
        'RSPNO': 'NO',
        'RSPOK': 'OK',
        'RSPACEPTAR': 'Akzeptieren',
        'CARGANDOLISTA': 'Warten Sie einen Moment, bis Sie die Teilnehmerliste abgerufen haben'

      },

      'WIZARD':{
        'CARGANDOF': 'Erfasste Produkte laden',
        'SINPRODS': 'Sie haben dieses Produkt nicht erworben',
        'KREARENC': 'Umfrage erstellen',
        'DONE': 'Anwendungsjahr: ',
        'TITULO': 'WILLKOMMEN IM FOKUSBEREICH',
        'TFOCUS': 'UMFRAGE ZUM FOKUSBEREICH',
        'DELETE': 'Löschen',
        'EDIT': 'Bearbeiten',
        'VERIPRE': 'Fragen prüfen',
        'AVANCE':'Vorrücken',
        'TITUVERI':'Überprüfung der Fragen',
        'TITUTABTEM':'Fragen zu Vorlagen',
        'TITUTABADI':'Angepasste Fragen',
        'TITUTAUTORIZADA':'Autorisierte Umfrage',
        'TITUTNOAUTORIZADA':'Umfrage nicht autorisieren',
        'TITUTAUTORIZAR':'Umfrage autorisieren',
        'TITUTCORREGIR':'Umfrage korrigieren',
      },
      'TABLACAMPOS':{
        'NAME':'Name der Umfrage',
        'FECHAI':'Startdatum',
        'FECHAF':'Zieldatum',
        'AVANCE':'Vorlauf',
        'ESTADO': 'Status',
        'ACCION': 'Aktionen',
      },
      'COLABORADORES':{
        'CARGACOLAB':'Zertifizierte Mitarbeiter hochladen'
      },
      'GRUPOS':{
        'NOMBRE_OK': "Se agrego correctamente el nombre",
        'DESCRIPCION_OK': "Se agrego correctamente la descripcion",
      },
      'ADMIN-PREG':{
        'TITULO-ABIE':'Offene Fragen',
        'PREGUN':'Fragen',
        'PREGUNSUB':'Frage',
        'DESCRIP-PREGUN':'Hier klicken, um die Frage anzuzeigen',
        'TITULO-UNAOPC':'Ein-Auswahl-Fragen',
        'TITULO-MULOPC':'Multiple-Choice-Fragen',
        'OPC':'Optionen',
        'OPCSUB':'Option',
        'NO-ADICI':'Die Umfrage hat keine zusätzlichen Fragen',
      },
      'IDIOM-NATIVO':{
        'pt':'Portugues',
        'es':'Español',
        'en':'English',
      },
      'STEP_COLAB':{
        'STEP_1':{
          'TITULO_STEP_ELEGIR_COLAB':'Auswahltyp der Mitwirkenden',
          'INST_1':'Wählen Sie eine der folgenden Optionen',
          'NUEVA_BASE_COLA':'Neue Mitwirkenden-Basis hochladen',
          'BASE_COLAB_EXIS':'Hauptmitarbeiterbasis verwenden',
          'BTN_SIGUENTE':'Weiter',

        },
        'STEP_2':{
          'TITULO_STEP_SUBIR_COLAB':'Auswahl der Mitwirkenden',
          'MAT_TITLE_DEMO_SELE':'Ausgewählte Demografien',
          'ALERT_NOT_DEMO_SELE':'Sie haben noch keine Filter ausgewählt',
          'ALERT_NOT_SELE_COLAB':'Keine Mitwirkenden hinzugefügt',
          'AGREGAR_FILTRO':'Filter hinzufügen',
          'TH_NOMBRE':'Mitwirkender Name',
          'TH_ACCION':'Aktionen',
          'INTS_SEL_1_O_MAS_COLAB':'*Hinweis: Wählen Sie einen oder mehrere Kollaborateure',
          'SIN_RESULTADOS':'Die aktuelle Filterauswahl hat keine Ergebnisse zurückgegeben. Versuchen Sie, die Filter zu wechseln, und versuchen Sie es erneut',
          'BTN_REGRESAR':'Rückgabe',
          'BTN_AGRE_COLAB':'Kollaborateure hinzufügen',
          'BTN_GUAR_COLAB':'Mitwirkende speichern',
          'BTN_BORR_COLAB':'Mitwirkende löschen',
          'BTN_ACEPTAR':'Akzeptieren',
          'BTN_BUSCAR':'Suchen',
          'TITULO_MODAL_DEMOGRA':'Liste der Demografien',
          'MAT_TITLE_EXPA_RESULT':'Mitwirkende Suchergebnisse:',
          'MAT_TITLE_EXPA_AGREG':'Mitwirkende aggregieren:',
          'MAT_TITLE_EXPA_DESCRIP':'Siehe Mitwirkende',
          'MODALES':{
            'MODAL_CARGAN_FILTROS':'Laden von Filtern',
            'MODAL_BUSCA_COLAB':'Suchen nach gefilterten Mitwirkenden',
            'MODAL_AGRE_COLAB':'Hinzufügen von Mitwirkenden',
            'MODAL_DELET_COLAB':'Löschen von Informationen über Mitwirkende',
            'MODAL_SUCCES_AGRE_COLAB':'Mitwirkende wurden erfolgreich hinzugefügt',
            'MODAL_GUAR_COLAB':'Kollaborateure speichern',
            'MODAL_CONFIR_BORRAR_COLAB':'Sind Sie sicher, dass Sie den Mitwirkenden löschen wollen?',
            'MODAL_CONFIR_BORRAR_COLABRES':'Sind Sie sicher, dass Sie die Mitwirkenden löschen wollen?',
            'MODAL_CONFIR_GUAR_COLAB_BACK':'Sind Sie sicher, dass die hinzugefügten Mitwirkenden gespeichert werden sollen?',
            'MODAL_SUCCES_GUAR_COLAB':'Mitwirkende wurden korrekt gespeichert',
            'MODAL_SUCCES_BORRA_COLAB':'Mitwirkende wurden korrekt gelöscht',
            'MODAL_SUCCES_BORRA_COLABRES':'Mitwirkende wurden erfolgreich gelöscht',
            'MODAL_WARNN_NO_SELECT_COLAB':'Sie haben noch keinen Mitwirkenden ausgewählt',
            'BTN_SI':'Ja',
            'BTN_NO':'Nein',
            'BTN_OK':'Ok',
          },
          'FORMULARIO':{
            'fullName': 'FULL NAME',
            'ownKey': 'MITARBEITERNUMMER',
            'age': 'GEBURTSJAHR',
            'surveyKey': 'SURVEY ACCESS KEY',
            'email': 'EMAIL',
            'bossName': 'NAME DES DIREKTEN VORSITZENDEN',
            'bossKey': 'DIRECT BOSS NUMBER',
            'country': 'LAND',
            'location': 'LOCATION',
            'geo_1': 'GEOGRAPHISCHE EBENE 1',
            'geo_2': 'GEOGRAPHISCHE EBENE 2',
            'geo_3': 'GEOGRAPHISCHE EBENE 3',
            'geo_4': 'GEOGRAPHISCHE EBENE 4',
            'geo_5': 'GEOGRAPHISCHE EBENE 5',
            'geo_6': 'GEOGRAPHISCHE EBENE 6',
            'geo_7': 'GEOGRAPHISCHE EBENE 7',
            'geo_8': 'GEOGRAPHISCHE EBENE 8',
            'geo_9': 'GEOGRAPHISCHE EBENE 9',
            'geo_10': 'GEOGRAPHISCHE EBENE 10',
            'structure_1': 'STRUKTURENSTUFE 1',
            'structure_2': 'STRUKTURIERUNGSSTUFE 2',
            'structure_3': 'STRUKTURIERUNGSSTUFE 3',
            'structure_4': 'STRUKTURIERUNGSSTUFE 4',
            'structure_5': 'STRUKTURELLE EBENE 5',
            'structure_6': 'STRUKTURIERUNGSSTUFE 6',
            'structure_7': 'STRUKTURIERUNGSSTUFE 7',
            'structure_8': 'STRUKTURIERUNGSSTUFE 8',
            'structure_9': 'STRUKTURIERUNGSSTUFE 9',
            'structure_10': 'STRUKTURIERUNGSSTUFE 10',
            'area': 'AREA',
            'bUnit': 'GESCHÄFTSEINHEIT',
            'eintrittsdatum': 'datum des eintritts in die firma',
            'antiquity': 'ANTIQUITÄT',
            'antiquityUS': 'ANTIQUITY US',
            'generation': 'GENERATION',
            'generationUS': 'GENERATION US',
            'ageUS': 'AGE',
            'charge': 'STELLUNG ODER FUNKTION IM UNTERNEHMEN',
            'homologado': 'STELLUNG ODER FUNKTION ANERKANNT',
            'homologadoUS': 'TÄTIGKEIT ODER FUNKTION ANGENOMMEN US',
            'gender': 'GENDER',
            'genderType': 'TYP DES GESCHLECHTS',
            'typeofwork': 'TYPE OF COMPENSATION',
            'workCondition': 'ARBEITSBEDINGUNG',
            'academico': 'AKADEMISCHER ABSCHLUSS',
            'contratacion': 'VERTRAGSTYP',
            'situacionUS': 'ARBEITSSITUATION US',
            'personal': 'ARBEITGEBER-TYP',
            'jornada': 'ARBEITSZEITRAUM-TYP',
            'rotacion': 'DOES SHIFT ROTATION',
            'phone': 'COLLABORATOR S PHONE',
            'extension': 'DIREKTE ERWEITERUNG DES COLLABORATORS',
            'cellphone': 'KOLLABORATOR S CELLPHONE',
            'native': 'Muttersprache',
            'answer': 'ANTWORT',
            'other_1': 'ANDERE 1',
            'other_2': 'ANDERE 2',
            'other_3': 'ANDERE 3',
            'other_4': 'ANDERE 4',
            'other_5': 'ANDERE 5',
            'other_6': 'ANDERE 6',
            'other_7': 'ANDERE 7',
            'other_8': 'ANDERE 8',
            'other_9': 'ANDERE 9',
            'other_10': 'ANDERE 10',
          },
        },
    }

    }
  }
};
